let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4gx8n")).then(() => parcelRequire('XRx2v'));